import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { RichText } from '@atlassiansox/bxp-content-framework';
import { AnalyticsAttributesProvider } from '../../components';
import { renderViewModel } from '../../render-view-model';
import { Callout, CalloutMedia, CalloutIcon, CalloutText, CalloutHeading } from './UiCallout.styles';
export default function UiCallout({ model }) {
    const { type, content: { entryTitle, media, mediaOnRight, heading, text, icon, theme } } = model;
    return (_jsx(AnalyticsAttributesProvider, Object.assign({ value: {
            eventComponent: type,
            labelEnglish: entryTitle,
            parentLabel: heading
        } }, { children: _jsxs(Callout, Object.assign({ mediaOnRight: mediaOnRight }, { children: [_jsx(CalloutMedia, { children: renderViewModel(media) }, void 0), _jsxs(CalloutText, { children: [_jsxs(CalloutHeading, { children: [icon && (_jsx(CalloutIcon, Object.assign({ theme: theme }, { children: renderViewModel(icon) }), void 0)), _jsx("h3", { children: heading }, void 0)] }, void 0), _jsx(RichText, { document: text }, void 0)] }, void 0)] }), void 0) }), void 0));
}
//# sourceMappingURL=UiCallout.js.map